/**
 * Bilgilendirme amaçlı metinler (sözleşme / onay metni değildir).
 * Web ve mobil ile uyumlu kaynak.
 */

export const kvkkRemoteHealthInfoHtml = `
<p style="font-size:14px;color:#64748B;margin-bottom:20px;"><em>Bu metin bilgilendirme amaçlıdır; taraflar arasında sözleşme veya hukuki taahhüt oluşturmaz.</em></p>

<h3>KİŞİSEL VERİLERİN KORUNMASI KANUNU KAPSAMINDA UZAKTAN SAĞLIK HİZMETİ BİLGİLENDİRMESİ</h3>

<p>6698 sayılı Kişisel Verilerin Korunması Kanunu (&quot;KVKK&quot;) uyarınca, platform üzerinden yürütülen uzaktan sağlık hizmeti süreçlerinde kişisel verilerinizin işlenmesi hakkında sizi bilgilendirmekteyiz.</p>

<h4>1. Veri sorumlusu</h4>
<p>Kişisel verileriniz, veri sorumlusu sıfatıyla <strong>Zenam Bilişim Teknolojileri Yazılım ve Danışmanlık Ltd. Şti.</strong> tarafından işlenmektedir.</p>
<p><strong>Adres:</strong> OSTİM OSB Mahallesi, Cevat Dündar Caddesi, No:1/1/49, 06374 OSTİM TEKNOPARK, Yenimahalle/Ankara<br/>
<strong>E-posta:</strong> info@zenambilisim.com.tr<br/>
<strong>Telefon:</strong> +90 555 257 92 05<br/>
<strong>MERSİS No:</strong> 0997126677000001</p>

<h4>2. İşlenen veriler ve yöntem</h4>
<p>Uzaktan sağlık hizmeti kapsamında özellikle aşağıdaki veriler işlenebilir: kimlik ve iletişim bilgileri; randevu ve görüşme kayıtları; <strong>görüntülü görüşme sırasında işlenen kamera ve mikrofon verileri (görüntü ve ses akışı)</strong>; uygulama içi mesajlaşma içerikleri; sağlıkla ilgili beyan ve paylaşımlarınız (özel nitelikli kişisel veri); teknik kayıtlar (ör. bağlantı ve cihaz bilgileri).</p>
<p>Verileriniz; platform altyapısı üzerinden, elektronik ortamda ve hizmetin gerektirdiği süreyle işlenir.</p>

<h4>3. İşleme amaçları</h4>
<ul>
<li>Uzaktan sağlık görüşmesinin güvenli şekilde gerçekleştirilmesi</li>
<li>Hekim–hasta iletişiminin sağlanması ve kayıtların tutulması</li>
<li>Hizmet kalitesi, bilgi güvenliği ve yetkili mercilere karşı mevzuattan doğan yükümlülüklerin yerine getirilmesi</li>
</ul>

<h4>4. Hukuki sebep</h4>
<p>Özel nitelikli sağlık verileri bakımından KVKK ve ilgili mevzuatta öngörülen şartlar çerçevesinde; açık rızanızın bulunması, kanunda öngörülen istisnalar veya sağlık hizmetinin ifası için zorunlu olması gibi hukuki dayanaklara dayanılabilir. Platform kullanımı ve hizmet kapsamındaki işlemler, kayıt ve ayarlarınızla uyumlu şekilde yürütülür.</p>

<h4>5. Aktarım</h4>
<p>Kişisel verileriniz, yalnızca hizmetin sunulması için gerekli ölçüde; yetkili sağlık hizmeti sağlayıcıları, teknik altyapı ve güvenlik hizmeti sağlayıcıları ile ve kanuni zorunluluklar kapsamında yetkili kurumlarla paylaşılabilir.</p>

<h4>6. Haklarınız</h4>
<p>KVKK’nın 11. maddesi kapsamında; verilerinizin işlenip işlenmediğini öğrenme, işlenmişse bilgi talep etme, işlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme, yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme, eksik veya yanlış işlenmişse düzeltilmesini isteme, KVKK’da öngörülen şartlar çerçevesinde silinmesini veya yok edilmesini isteme, otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme ve kanuna aykırı işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme haklarına sahipsiniz.</p>
<p>Başvurularınızı yukarıdaki iletişim kanalları üzerinden iletebilirsiniz.</p>
`;

export const remoteHealthServiceTermsInfoHtml = `
<p style="font-size:14px;color:#64748B;margin-bottom:20px;"><em>Bu metin bilgilendirme amaçlıdır; taraflar arasında sözleşme veya hukuki taahhüt oluşturmaz.</em></p>

<h3>UZAKTAN SAĞLIK HİZMETİ SUNUMUNA İLİŞKİN ŞARTLAR VE BİLGİLENDİRME</h3>

<p>Bu bölüm, platform üzerinden gerçekleştirilen <strong>uzaktan sağlık (tele-sağlık) görüşmeleri</strong> öncesinde tarafların bilgilendirilmesi amacıyla hazırlanmıştır.</p>

<h4>1. Hizmetin kapsamı</h4>
<p>Uzaktan sağlık hizmeti; uygun teknik koşulların sağlanması şartıyla, sağlık profesyoneli ile hasta arasında <strong>görüntülü ve/veya sesli</strong> iletişim ve uygulama içi mesajlaşma yoluyla yürütülen danışmanlık ve değerlendirme süreçlerini ifade eder. Platformu işleten taraf: <strong>Zenam Bilişim Teknolojileri Yazılım ve Danışmanlık Ltd. Şti.</strong> (adres ve iletişim bilgileri aşağıdadır).</p>

<h4>2. Teknik gereksinimler ve izinler</h4>
<p>Görüşmeye katılabilmek için cihazınızda <strong>kamera ve mikrofon</strong> erişiminin verilmesi gerekebilir. İstikrarlı internet bağlantısı, güncel tarayıcı veya uygulama sürümü ve uygun ortam (gizlilik, aydınlatma) sağlanması kullanıcının sorumluluğundadır.</p>

<h4>3. Kullanıcı yükümlülükleri</h4>
<ul>
<li>Kimlik ve sağlıkla ilgili beyanlarda doğru ve güncel bilgi verilmesi</li>
<li>Görüşme sırasında üçüncü kişilerin izinsiz kayda alınmaması ve gizliliğin ihlal edilmemesi</li>
<li>Acil durumlarda 112 veya en yakın sağlık kuruluşuna başvurulması</li>
</ul>

<h4>4. Sınırlamalar</h4>
<p>Uzaktan görüşme; yüz yüze muayene, acil müdahale veya fizik muayene gerektiren durumların yerine geçmez. <strong>Yaşamı tehdit eden durumlarda</strong> derhal acil sağlık hizmetlerine başvurmanız gerekir.</p>

<h4>5. Sağlık hizmeti ve platform ayrımı</h4>
<p>Tıbbi değerlendirme ve tedavi kararları ilgili <strong>sağlık profesyoneline</strong> aittir. Zenam Bilişim Teknolojileri Yazılım ve Danışmanlık Ltd. Şti., yazılım ve iletişim altyapısı sağlayıcısı olarak hizmet sunmakta; tıbbi tanı veya tedavi taahhüdünde bulunmamaktadır.</p>

<h4>6. İletişim</h4>
<p><strong>Adres:</strong> OSTİM OSB Mahallesi, Cevat Dündar Caddesi, No:1/1/49, 06374 OSTİM TEKNOPARK, Yenimahalle/Ankara<br/>
<strong>E-posta:</strong> info@zenambilisim.com.tr<br/>
<strong>Telefon:</strong> +90 555 257 92 05<br/>
<strong>MERSİS No:</strong> 0997126677000001</p>
`;
